<div class="s-12 m-12 l-6 margin-top-10">
    <div>
        <ul class="top-bar-social right xxx">                      
          <app-basket></app-basket>
          <app-favorites></app-favorites>           
          <app-login></app-login>
        </ul>
    </div>
</div>